import { useAuth } from "@/context/AuthContext";
import { StarMark } from "@/components/Logo";
import { MfaEnroll } from "@/components/MfaEnroll";
import { ShieldAlert } from "lucide-react";

/**
 * Blocking screen shown when organisation policy requires MFA but the user
 * hasn't enrolled yet. Mirrors the ForcePasswordChange pattern.
 */
export const ForceMfaSetup = () => {
  const { refreshUser, logout } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-ek-canvas px-6" data-testid="force-mfa-setup">
      <div className="w-full max-w-md rounded-2xl border border-black/5 bg-white p-8 shadow-sm">
        <div className="flex items-center gap-2.5">
          <StarMark size={26} className="text-ek-purple" />
          <span className="font-display text-lg font-bold text-ek-ink">EKSELENS <span className="text-ek-purple">· ERIO</span></span>
        </div>
        <div className="mt-6 flex items-center gap-2 text-ek-purple">
          <ShieldAlert size={18} />
          <p className="text-sm font-semibold">Two-factor authentication required</p>
        </div>
        <p className="mt-2 text-sm text-ek-ink/65">
          Your organisation requires all admins to use two-factor authentication. Please set it up
          to continue.
        </p>
        <div className="mt-5">
          <MfaEnroll onDone={refreshUser} />
        </div>
        <button
          type="button"
          onClick={logout}
          data-testid="force-mfa-signout"
          className="mt-6 text-sm text-ek-ink/65 hover:text-ek-purple"
        >
          Sign out
        </button>
      </div>
    </div>
  );
};
